var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UnitTestRun_1;
import { DateConverter, JSON, JsonConverter, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { unitTestRunSchemaValidation } from '../validations.generated';
export var UnitTestStatus;
(function (UnitTestStatus) {
    UnitTestStatus["Passed"] = "passed";
    UnitTestStatus["Failed"] = "failed";
    UnitTestStatus["Error"] = "error";
    UnitTestStatus["Running"] = "running";
    UnitTestStatus["NoSnapshotFound"] = "noSnapshotFound"; // unit test has been ran but no snapshot to compare against
})(UnitTestStatus || (UnitTestStatus = {}));
export var UnitTestErrorCodes;
(function (UnitTestErrorCodes) {
    UnitTestErrorCodes["UnitTestNotFound"] = "unitTest.notFound";
    UnitTestErrorCodes["ConcurrentExecution"] = "unitTest.concurrentExecution";
    UnitTestErrorCodes["TooManyRows"] = "unitTest.tooManyRows";
    UnitTestErrorCodes["InvalidUnitTestConfig"] = "unitTest.invalidConfig";
    UnitTestErrorCodes["InvalidPipe"] = "unitTest.invalidPipe";
    UnitTestErrorCodes["UnitTestDataNotFound"] = "unitTest.dataNotFound";
    UnitTestErrorCodes["Unknown"] = "unitTest.unknown";
})(UnitTestErrorCodes || (UnitTestErrorCodes = {}));
export const unitTestRunSchema = {
    $id: 'urn:wisepipe-common-computation:UnitTestRun',
    type: 'object',
    properties: {
        unitTestID: { type: 'string', uid: 9 },
        status: { type: 'string', enum: Object.values(UnitTestStatus) },
        lastRunBy: { type: 'string', format: 'uuid' },
        lastRunAt: { type: 'string', format: 'date-time' },
        taskID: { type: 'string', minLength: 1 },
        error: { type: 'object' }
    },
    required: ['unitTestID', 'status'],
    if: { not: { properties: { status: { const: UnitTestStatus.Running } } } },
    then: { required: ['lastRunBy', 'lastRunAt'] }
};
let UnitTestRun = UnitTestRun_1 = class UnitTestRun {
    constructor(unitTestID, status, lastRunBy, lastRunAt, taskID, error) {
        this.unitTestID = unitTestID;
        this.status = status;
        if (lastRunBy !== undefined)
            this.lastRunBy = lastRunBy;
        if (lastRunAt !== undefined)
            this.lastRunAt = lastRunAt;
        if (taskID !== undefined)
            this.taskID = taskID;
        if (error !== undefined)
            this.error = error;
        JSON.validate(this, UnitTestRun_1);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], UnitTestRun.prototype, "lastRunAt", void 0);
UnitTestRun = UnitTestRun_1 = __decorate([
    JsonSchemaV2(unitTestRunSchema, unitTestRunSchemaValidation)
], UnitTestRun);
export { UnitTestRun };
//# sourceMappingURL=unitTestRun.js.map